var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuppliers = function SvgSuppliers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M19 19.002v1A1 1 0 0 1 18 21H6a1 1 0 0 1-1-.999v-1.015C5 15.964 8.458 14 12 14s7 1.965 7 4.986M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgSuppliers;